import { View } from 'foundations-components/components/View';
import CertificationsOverview from '../components/overview/CertificationsOverview';
import TeamMembersOverview from '../components/overview/TeamMembersOverview';
import PlaylistsOverview from '../components/overview/PlaylistsOverview';
import UsageTracker from '../../../utils/UsageTracker';
import { MY_TEAM_URL_FRAGMENT, PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'quartz-routing/react-router';
import { useProgressTransferVerification } from '../hooks/useProgressTransferVerification';
import ProgressTransferVerifiedModal from 'academy-common-lib/features/certificate/components/progressTransfer/components/ProgressTransferVerifiedModal';
import ApiError from '../../../components/Errors/ApiError';
import { PageHeader } from '../../header/components/PageHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RedirectToMyTeamOverview = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: MY_TEAM_URL_FRAGMENT
    })
  });
};
const MyTeamOverview = () => {
  const history = useHistory();
  const {
    shouldShowModal,
    error: progressTransferVerificationError,
    isVerified: progressTransferVerified
  } = useProgressTransferVerification();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM
    });
  }, []);
  const redirectToMyTeamPage = () => {
    history.push(MY_TEAM_URL_FRAGMENT);
  };
  const handleTrackEvent = eventProps => {
    UsageTracker.track('teamInteraction', eventProps);
  };
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_OVERVIEW"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_OVERVIEW"
      })
    }), /*#__PURE__*/_jsx(CertificationsOverview, {}), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(TeamMembersOverview, {})
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(PlaylistsOverview, {})
    }), shouldShowModal && /*#__PURE__*/_jsx(ProgressTransferVerifiedModal, {
      ErrorComponent: ApiError,
      error: progressTransferVerificationError,
      onConfirm: redirectToMyTeamPage,
      progressTransferVerified: progressTransferVerified,
      trackEvent: eventProps => {
        if (eventProps) {
          handleTrackEvent(eventProps);
        }
      }
    })]
  });
};
export default MyTeamOverview;